// web/src/api/session.ts — session state-sync endpoint wrapper.
//
// GET /api/sessions/:id/current returns the authoritative TaskNextState
// the server believes the session is on. Used by the card screen on
// pause-resume to reconcile any drift between client and server view
// (the rare case where the in-flight turn's FSM advance committed
// before the abort propagated).
//
// Authenticated path (RequireSession + DoubleSubmitCSRF inherited from
// the /api/sessions sub-router); GET so no CSRF header is required.

import { type TaskNextState } from "../types/api.js";

export async function getSessionCurrent(
  sessionId: string,
  opts: { signal?: AbortSignal } = {},
): Promise<TaskNextState> {
  const res = await fetch(
    `/api/sessions/${encodeURIComponent(sessionId)}/current`,
    {
      method: "GET",
      credentials: "include",
      signal: opts.signal,
    },
  );
  if (!res.ok) throw new Error(`getSessionCurrent: ${res.status}`);
  return res.json() as Promise<TaskNextState>;
}
